var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"application-line",attrs:{"id":"app-name"}},[_c('h1',[_vm._v(_vm._s(_vm.game_os.name))])]),_vm._v(" "),_vm._l((_vm.game_os.versions),function(version){return _c('div',{key:version.name},[_c('h1',[_vm._v(_vm._s(version.name))]),_c('br'),_vm._v(" "),_c('LevelsChart',{attrs:{"levels":version.levels}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3695154","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/GameOsStatistic.vue
// module id = 110
// module chunks = 0